import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { PageAction } from '../../components/page-actions/page-actions.component';
import { ImportLogsService } from '@services/import-logs/import-logs.service';
import { ImportService } from '@services/imports/import.service';
import { ImportTypeService } from '@services/import-types/import-type.service';
import { DataTableEvent } from '../../components/data-table/data-table.component';

@Component({
    selector: 'app-import-logs',
    templateUrl: './import-logs.component.html',
    styleUrls: ['./import-logs.component.scss'],
    providers: [ImportLogsService, ImportService, ImportTypeService],
    standalone: false
})
export class ImportLogsComponent implements OnInit {

  @Input() id;
  @Input() type;

  public title = 'All Import Logs';

  public hasHeader = true;

  public subtitle: string;

  public pageActions: PageAction[];

  public filterId: string;

  public filterType: string;

  public importId: string = null;

  public importTypeId: string = null;

  public columns = [
    { prop: 'title', name: 'Title' },
    {
      prop: 'created', valueTransformer: function(date) {
        if (!date) { return null }
        return moment(date).format('DD-MM-YYYY  HH:mm');
      }
    },
    {
      prop: 'lastCheck', valueTransformer: function(date) {
        if (!date) { return null }
        return moment(date).format('DD-MM-YYYY  HH:mm');
      }
    },
    {
      prop: 'importWasSuccess', name: 'Failed', valueTransformer: function(data) {
        return data ? '' : 'Error';
      }
    }
  ];

  public params: any;

  constructor(
    public importLogsService: ImportLogsService,
    public importService: ImportService,
    public importTypeService: ImportTypeService,
    private route: ActivatedRoute,
    private router: Router
  ) {
  }

  ngOnInit() {

    this.filterId = this.id ? this.id : this.route.snapshot.params['id'];
    this.filterType = this.type ? this.type : this.route.snapshot.params['filter'];

    // If direct link from Import Detail-View, Id is Importer Id
    if (this.filterId && this.filterType === 'importId') {
      this.params = { importId: this.filterId };
      this.importService.get(this.filterId).then(responseImport => {
        this.importId = this.filterId;
        this.importTypeId = responseImport.typeId;
        this.importTypeService.get(responseImport.typeId).then(responseImportType => {
          this.title = 'Import Logs of Importer: ' + responseImport.title;
          this.subtitle = 'Import Type: ' + responseImportType.title;
        });
      });
      // If direct link from ImportType , Id is ImportType Id
    } else if (this.filterId && this.filterType === 'importTypeId') {
      this.importTypeService.get(this.filterId).then(responseImportType => {
        this.importTypeId = this.filterId;
        this.title = 'Import Logs of Import Type: ' + responseImportType.customId;
      });
      this.params = { importTypeId: this.filterId };
      // direct link to Log, Id is Log Id
    } else if (this.filterId && this.filterType === 'package') {
      this.params = { importId: this.filterId };
      this.hasHeader = false;
    } else if (this.filterId) {
      this.params = { _id: this.filterId };
      // end else all Logs
    } else {
      this.params = {};
    }
    this.params['$sort'] = { created: -1 };
    this.createPageActions();

  }

  public onDetail(event: DataTableEvent): void {
    this.router.navigate(['package-logs', event.row._id]);
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'subdirectory_arrow_left',
        title: 'Go to Importer',
        callback: () => {
          this.router.navigate(['imports/', this.importId]);
        }
      }),
      new PageAction({
        icon: 'subdirectory_arrow_left',
        title: 'Go to Importer Type',
        callback: () => {
          this.router.navigate(['import-types/', this.importTypeId]);
        }
      })
    ];
    if (this.filterType && this.filterType === 'importId') {
      this.pageActions.push(new PageAction({
        icon: 'info',
        title: 'Log Overview Import Type',
        callback: () => {
          this.router.navigate(['import-logs/', 'importTypeId', this.importTypeId]);
        }
      }));
    }
  }
}

